/**
 * Promo code ticket (snippets/dialed-promo-code.liquid): a tap copies the code and the ticket
 * shows "Copied" for a moment. Screen readers hear it through the ticket's status line.
 */
const RESET_MS = 2200;

/** @param {string} text */
async function copy(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Older browsers and non-secure pages: copy from a hidden field
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
    document.body.append(field);
    field.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch {}
    field.remove();
    return ok;
  }
}

if (!window.__dialedPromo) {
  window.__dialedPromo = true;
  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-promo-code]') : null;
    if (!(button instanceof HTMLElement)) return;
    const code = button.dataset.promoCode ?? '';
    if (!(await copy(code))) return;

    const label = button.querySelector('[data-promo-label]');
    const status = button.querySelector('[data-promo-status]');
    const copied = button.dataset.copiedLabel ?? '';
    if (label && !label.dataset.text) label.dataset.text = label.textContent ?? '';
    if (label) label.textContent = copied;
    if (status) status.textContent = `${copied}: ${code}`;
    button.setAttribute('data-copied', '');

    window.clearTimeout(Number(button.dataset.timer));
    button.dataset.timer = String(
      window.setTimeout(() => {
        button.removeAttribute('data-copied');
        if (label) label.textContent = label.dataset.text ?? '';
        if (status) status.textContent = '';
      }, RESET_MS),
    );
  });
}
